module.exports = __webpack_public_path__ + "static/media/icono-recursos.f0023263.svg";